import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"
import _imports_0 from '../../../assets/filter/box-open.svg'


const _hoisted_1 = { id: "modais" }
const _hoisted_2 = {
  class: "modal fade",
  id: "ModalJSONIntegracao",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalCenterTitle",
  "aria-hidden": "true"
}
const _hoisted_3 = {
  class: "modal-dialog modal-lg modal-dialog-centered",
  role: "document"
}
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "d-flex flex-column gap-4" }
const _hoisted_7 = {
  key: 0,
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_8 = {
  key: 1,
  class: "modal-title",
  id: "exampleModalLongTitle"
}
const _hoisted_9 = { style: {"color":"#464e5f"} }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn-close",
  "data-bs-dismiss": "modal",
  "aria-label": "Close"
}, null, -1)
const _hoisted_11 = { class: "col-12 d-flex flex-column p-0 gap-3 p-4" }
const _hoisted_12 = {
  key: 0,
  style: {"background":"#203972","border-radius":"10px 10px 0px 0px"},
  class: "col-12 p-5 d-flex flex-row"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bold m-0 col-3 d-flex justify-content-center" }, "METODO", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bold m-0 col-3 d-flex justify-content-center" }, "DATA", -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bold m-0 col-3 d-flex justify-content-center" }, "URL", -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("span", { class: "text-white fw-bold m-0 col-3 d-flex justify-content-center" }, "AÇÃO", -1)
const _hoisted_17 = [
  _hoisted_13,
  _hoisted_14,
  _hoisted_15,
  _hoisted_16
]
const _hoisted_18 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_19 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_20 = {
  class: "col-3 d-flex justify-content-center",
  style: {"word-break":"break-all"}
}
const _hoisted_21 = { class: "col-3 d-flex justify-content-center" }
const _hoisted_22 = ["onClick"]
const _hoisted_23 = {
  key: 1,
  class: "d-flex flex-column"
}
const _hoisted_24 = {
  key: 2,
  class: "d-flex flex-column"
}
const _hoisted_25 = {
  key: 3,
  class: "card d-flex h-100 justify-content-center",
  id: "empty"
}
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h3", { style: {"color":"rgb(213 202 202)"} }, "Nenhuma requisição para ser exibida.", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("img", {
  class: "m-5",
  src: _imports_0,
  alt: ""
}, null, -1)
const _hoisted_28 = [
  _hoisted_26,
  _hoisted_27
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (!_ctx.jsonIntegracao)
                ? (_openBlock(), _createElementBlock("h5", _hoisted_7, "Verifique o histórico detalhado da requisição"))
                : (_openBlock(), _createElementBlock("h5", _hoisted_8, "Verifique o status do atendimento na integração ")),
              _createElementVNode("h6", _hoisted_9, _toDisplayString(_ctx.nomeEmpresaDinamico), 1)
            ]),
            _hoisted_10
          ]),
          _createElementVNode("ul", _hoisted_11, [
            (!_ctx.jsonIntegracao)
              ? (_openBlock(), _createElementBlock("li", _hoisted_12, _hoisted_17))
              : _createCommentVNode("", true),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.json, (atendimento, key) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "listaZebra col-12 d-flex flex-row align-items-center",
                key: key
              }, [
                _createElementVNode("span", _hoisted_18, _toDisplayString(atendimento.metodo), 1),
                _createElementVNode("span", _hoisted_19, _toDisplayString(_ctx.formatDate(atendimento.created_at)), 1),
                _createElementVNode("p", _hoisted_20, _toDisplayString(atendimento.url), 1),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("button", {
                    class: "btn btn-danger",
                    onClick: ($event: any) => (_ctx.clickedJson(atendimento.id))
                  }, "JSON", 8, _hoisted_22)
                ])
              ]))
            }), 128)),
            (Object.keys(_ctx.Jsonfiltered).length == 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                  _createElementVNode("button", {
                    class: "btn btn-light-danger d-flex d-inline-block flex-row justify-content-center align-items-center p-3",
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.copyContent && _ctx.copyContent(...args)))
                  }, "Clique aqui para copiar o JSON"),
                  _createElementVNode("pre", {
                    id: "texto",
                    ref: "contentJson",
                    class: "fs-7",
                    style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                  }, _toDisplayString(_ctx.jsonIntegracao), 513)
                ]))
              : _createCommentVNode("", true),
            (Object.keys(_ctx.Jsonfiltered).length !== 0 )
              ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                  _createElementVNode("button", {
                    class: "btn btn-light-danger d-flex d-inline-block flex-row justify-content-center align-items-center p-3",
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.copyContent && _ctx.copyContent(...args)))
                  }, "Clique aqui para copiar o JSON"),
                  _createElementVNode("pre", {
                    id: "texto",
                    ref: "contentJson",
                    class: "fs-7",
                    style: {"white-space":"pre-wrap","word-wrap":"break-word"}
                  }, _toDisplayString(JSON.stringify(_ctx.Jsonfiltered, null, 2).replaceAll('\\', '')), 513)
                ]))
              : _createCommentVNode("", true),
            (!_ctx.jsonIntegracao && !_ctx.Jsonfiltered)
              ? (_openBlock(), _createElementBlock("div", _hoisted_25, _hoisted_28))
              : _createCommentVNode("", true)
          ])
        ])
      ])
    ])
  ]))
}